/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Table_ActionInputs */

const en_options_api_keys_table_action = /** @type {(inputs: Options_Api_Keys_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const fr_options_api_keys_table_action = /** @type {(inputs: Options_Api_Keys_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const de_options_api_keys_table_action = /** @type {(inputs: Options_Api_Keys_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktion`)
};

const it_options_api_keys_table_action = /** @type {(inputs: Options_Api_Keys_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azione`)
};

const ru_options_api_keys_table_action = /** @type {(inputs: Options_Api_Keys_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Действие`)
};

const es_options_api_keys_table_action = /** @type {(inputs: Options_Api_Keys_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acción`)
};

const zh_cn2_options_api_keys_table_action = /** @type {(inputs: Options_Api_Keys_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行动`)
};

const ja_options_api_keys_table_action = /** @type {(inputs: Options_Api_Keys_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクション`)
};

const hi_options_api_keys_table_action = /** @type {(inputs: Options_Api_Keys_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्रवाई`)
};

const pt_pt2_options_api_keys_table_action = /** @type {(inputs: Options_Api_Keys_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ação`)
};

/**
* | output |
* | --- |
* | "Action" |
*
* @param {Options_Api_Keys_Table_ActionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_table_action = /** @type {((inputs?: Options_Api_Keys_Table_ActionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Table_ActionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_table_action(inputs)
	if (locale === "de") return de_options_api_keys_table_action(inputs)
	if (locale === "it") return it_options_api_keys_table_action(inputs)
	if (locale === "ru") return ru_options_api_keys_table_action(inputs)
	if (locale === "es") return es_options_api_keys_table_action(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_table_action(inputs)
	if (locale === "ja") return ja_options_api_keys_table_action(inputs)
	if (locale === "hi") return hi_options_api_keys_table_action(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_table_action(inputs)
	return en_options_api_keys_table_action(inputs)
});